module.exports = __webpack_public_path__ + "img/avatar-planet-sad.47439849.svg";